// extracted by mini-css-extract-plugin
export default {"fadeInOut":"VIPWriting_fadeInOut__4xiNJ","custom_file_upload":"VIPWriting_custom_file_upload__CC1uX"};